import { DocumentTypeEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function documentTypeOptions(): SelectOption<string>[] {
  return [
    DocumentTypeEnum.arrival_notice,
    DocumentTypeEnum.land_transportation_import,
    DocumentTypeEnum.land_transportation_export,
    DocumentTypeEnum.customs_clearance_import,
    DocumentTypeEnum.customs_clearance_export,
    DocumentTypeEnum.sea_waybill,
    DocumentTypeEnum.original_bill_of_landing,
    DocumentTypeEnum.shipping_instructions
  ].map((val: DocumentTypeEnum) => {
    return { value: val, label: i18n.t(`documentType.${val}`).toString() };
  });
}
